import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';
import moment from 'moment';
import WebApp from '@twa-dev/sdk'
import { useMainButton } from '../hooks/useMainButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import 'moment/locale/ru';

moment.locale('ru');

function CommentsPage({ postId }) {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const [fetchError, setFetchError] = useState(false);

  const fetchComments = async () => {
    setIsFetching(true);
    setFetchError(false);
    try {
      const response = await api.get(`/api/comments/${postId}`);
      setComments(response.data);
    } catch (error) {
      setFetchError(true);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchComments();
  }, [postId]);

  const handleSubmit = useCallback(async () => {
    if (isLoading) return;
    setIsLoading(true);

    if (newComment.length < 1 || newComment.length > 1000) {
      WebApp.showAlert('Длина комментария должна быть от 1 до 1000 символов.');
      WebApp.HapticFeedback.notificationOccurred('error');
      setIsLoading(false);
      return;
    }
    try {
      const response = await api.post(`/api/comments/post`, {
        message_id: postId,
        text: newComment,
      });

      if (response.status === 200) {
        WebApp.HapticFeedback.notificationOccurred('success');
        setNewComment('');
        fetchComments();
      } else {
        WebApp.showAlert('Произошла ошибка при добавлении комментария.');
        WebApp.HapticFeedback.notificationOccurred('error');
      }
      setIsLoading(false);
    } catch (error) {
      WebApp.showAlert('Произошла ошибка при добавлении комментария.');
      WebApp.HapticFeedback.notificationOccurred('error');
      setIsLoading(false);
    }
  }, [newComment, isLoading, postId]);

  useMainButton({
    text: 'Отправить',
    onClick: handleSubmit,
    visible: true,
    disabled: !newComment.trim() || isLoading,
    showProgress: isLoading
  });

  useEffect(() => {
    if (newComment.trim()) {
      WebApp.enableClosingConfirmation();
    } else {
      WebApp.disableClosingConfirmation();
    }
    return () => WebApp.disableClosingConfirmation();
  }, [newComment]);

  if (isFetching) {
    return (
      <div className="flex justify-center items-center h-screen">
        <FontAwesomeIcon icon={faSpinner} spin className="text-tg-hint text-2xl" />
      </div>
    );
  }

  if (fetchError) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <p className="text-tg-hint">Не удалось загрузить комментарии</p>
        <button onClick={fetchComments} className="py-2 px-4 rounded-lg bg-tg-button text-tg-button-text border-none cursor-pointer">
          Повторить
        </button>
      </div>
    );
  }

  return (
    <div className="bg-tg-bg p-5 rounded">
        {comments.length === 0 ? (
          <p className="text-center text-tg-hint py-8">Нет комментариев</p>
        ) : (
          comments.map((comment) => (
            <div key={comment.comment_id} className="mb-2.5">
                <a href={`tg://user?id=${comment.author_telegram_id}`} className="no-underline text-tg-text">
                    <h2 className="text-lg font-bold">{comment.author_name}</h2>
                </a>
                <p className="text-sm mb-1 text-tg-text">{comment.text}</p>
                <p className="text-xs text-tg-hint">
                    {moment.utc(comment.created_at).local().fromNow()}
                </p>
            </div>
          ))
        )}
        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className="flex flex-col gap-2.5">
            <textarea
                className="border rounded-lg p-2 w-full max-w-[600px] bg-tg-bg text-tg-text border-tg-secondary-bg outline-none mb-1"
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                placeholder="Оставить комментарий"
            />
        </form>
    </div>
  );
}

export default CommentsPage;
